import React, { useState } from "react"
import { FieldRenderProps } from "react-final-form"
import DebouncedSearchDropdown from "./DebouncedSearchDropdown"

type Props = FieldRenderProps<any, HTMLElement> & {
  fetchSuggestions: (query: string) => Promise<string[]>
  nudgeOption?: any
  defaultSuggestions?: string[]
  placeholder?: string
  handleInputChange?: (val: string) => void
}

const SearchDropDown: React.FC<Props> = ({
  input,
  meta,
  fetchSuggestions,
  defaultSuggestions,
  placeholder,
  handleInputChange,
}) => {
  const [selectedValue, setSelectedValue] = useState(input.value || "")

  const handleChange = (val: string) => {
    handleInputChange && handleInputChange(val)
    setSelectedValue(val)
    input.onChange(val)
  }

  return (
    <div>
      <DebouncedSearchDropdown
        value={selectedValue}
        onChange={handleChange}
        fetchSuggestions={fetchSuggestions}
        placeholder={placeholder}
        defaultSuggestions={defaultSuggestions}
        onBlur={input.onBlur}
        onFocus={input.onFocus}
      />

      {meta.touched && meta.error && (
        <span className="mt-1 text-xs text-red-600">{meta.error}</span>
      )}
    </div>
  )
}

export default SearchDropDown
